import axios from 'axios';
import Vue from 'vue';
import { Unauthorized } from '../exceptions';

const instance = axios.create({
  baseURL: Vue.env.VUE_APP_APIPATH_Authentication
});

instance.interceptors.response.use((response) => response.data, (error) => {
  const resp = error.response;
  switch (resp.status) {
    case 401:
      throw new Unauthorized(resp.data);
    default:
      return Promise.reject(resp.data);
  }
});

/**
 * 登入
 * @param {string} account account
 * @param {string} password password
 * @param {string} captcha captcha
 * @returns {promise} promise object, result: api result
 */
export async function LoginAsync(account, password, captcha) {
  const url = '/api/v1/login';

  const data = {
    account,
    password,
    captcha
  };

  return instance.post(url, data);
}

/**
 * 登出
 * @param {string} accessToken access token
 * @returns {promise} promise object, result: api result
 */
export async function LogoutAsync(accessToken) {
  const url = '/api/v1/logout';

  return instance.post(url, null, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });
}

/**
 * 驗證
 * @param {string} accessToken access token
 * @returns {promise} promise object, result: api result
 */
export async function VerifyAsync(accessToken) {
  const url = '/api/v1/verify';

  return instance.get(url, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });
}

/**
 * Refresh
 * @param {string} refreshToken refresh token
 * @returns {promise} promise object, result: api result
 */
export async function RefreshAsync(refreshToken) {
  const url = '/api/v1/accesstoken/refresh';

  const data = {
    refresh_token: refreshToken
  };

  return instance.post(url, data);
}

/**
 * Temp
 * @param {string} tempToken temp token
 * @returns {promise} promise object, result: api result
 */
export async function IssueTempAsync(tempToken) {
  const url = '/api/v1/accesstoken/temp';

  const data = {
    temp_token: tempToken
  };

  return instance.post(url, data);
}

/**
 * 撤銷 Access Token
 * @param {string} accessToken access token
 * @returns {promise} promise object, result: api result
 */
export async function RevokeAsync(accessToken) {
  const url = '/api/v1/accesstoken/revoke';

  return instance.post(url, null, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });
}
